
import { Component } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";

@Component
export default class MainList extends HcPageModel {
    public name: string = "main-list";
    protected pageName: string = 'mainList';

    private clearForm(): void {
        this.$emit("clearForm");
    }

    private sendForm(): void {
        this.$emit("sendForm");
    }
}
